import { z } from 'zod';
export const healthSchema = z.object({
    status: z.literal('ok'),
    service: z.string(),
    version: z.string(),
    timestamp: z.string().datetime(),
});
//# sourceMappingURL=health.js.map